import { useCallback } from 'react';
import { WaveSurferRef } from './types';

export const useSeekTo = (waveSurferRef: WaveSurferRef) => {
  return useCallback(
    (progressSeconds: number) => {
      waveSurferRef.current?.seekTo(progressSeconds);
    },
    [waveSurferRef]
  );
};
